module.exports = __webpack_public_path__ + "img/16.a1fc595c.svg";